import { getLinkedItems } from '@/components/contexts/KontentHomeConfigProvider'
import type { Focusarea, Focusareaoption } from '@/kontent/content-types'
import type { IContentItemsContainer } from '@kontent-ai/delivery-sdk'
import type {
	PrescriptionContainer,
	PrescriptionsList,
	ResolvedListResult,
} from '../types'

const STATUS_OFFLINE = 'offline'
const STATUS_CURRENT = 'current'

const getListStatusCodename = (list: PrescriptionsList): string | undefined =>
	list.elements.status.value[0]?.codename

export const resolveList = (
	focusArea: Focusarea | Focusareaoption,
	linkedItems: IContentItemsContainer,
): ResolvedListResult | null => {
	const containers = (getLinkedItems(
		focusArea.elements.prescriptions,
		linkedItems,
	) ?? []) as PrescriptionContainer[]

	if (containers.length === 0) {
		return null
	}

	const seenListCodenames = new Set<string>()
	const referencedLists: PrescriptionsList[] = []

	for (const container of containers) {
		const listsForContainer =
			getLinkedItems(container.elements.prescription_list, linkedItems) ??
			[]

		for (const list of listsForContainer) {
			const codename = list.system.codename
			if (!seenListCodenames.has(codename)) {
				seenListCodenames.add(codename)
				referencedLists.push(list)
			}
		}
	}

	const setS = referencedLists.filter(
		(list) => getListStatusCodename(list) !== STATUS_OFFLINE,
	)

	if (setS.length === 0) {
		return null
	}

	let chosenList: PrescriptionsList | null = null

	if (setS.length === 1) {
		chosenList = setS[0]
	} else {
		const firstCurrent = setS.find(
			(list) => getListStatusCodename(list) === STATUS_CURRENT,
		)
		if (!firstCurrent) {
			return null
		}
		chosenList = firstCurrent
	}

	const chosenListCodename = chosenList.system.codename

	const filteredContainers = containers.filter((container) => {
		const listsForContainer =
			getLinkedItems(container.elements.prescription_list, linkedItems) ??
			[]
		return listsForContainer.some(
			(list) => list.system.codename === chosenListCodename,
		)
	})

	return { chosenList, filteredContainers }
}
